"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Info = function Info(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "18",
    height: "18",
    className: className,
    fill: color || "currentColor"
  }, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
  }), _react["default"].createElement("path", {
    d: "M8.05078 11.4922C8.05078 10.9727 8.11523 10.5586 8.24414 10.25C8.37305 9.94141 8.62695 9.60352 9.00586 9.23633C9.38867 8.86523 9.63086 8.60156 9.73242 8.44531C9.88867 8.20703 9.9668 7.94922 9.9668 7.67188C9.9668 7.30469 9.875 7.02539 9.69141 6.83398C9.51172 6.63867 9.24609 6.54102 8.89453 6.54102C8.55859 6.54102 8.28711 6.63672 8.08008 6.82812C7.87695 7.01562 7.77539 7.27148 7.77539 7.5957H6.35156C6.35938 6.9043 6.59375 6.35742 7.05469 5.95508C7.51953 5.55273 8.13281 5.35156 8.89453 5.35156C9.67969 5.35156 10.291 5.55078 10.7285 5.94922C11.1699 6.34766 11.3906 6.9043 11.3906 7.61914C11.3906 8.25586 11.0938 8.88281 10.5 9.5L9.7793 10.209C9.52148 10.502 9.38867 10.9297 9.38086 11.4922H8.05078ZM7.95117 13.3145C7.95117 13.084 8.02344 12.8984 8.16797 12.7578C8.3125 12.6133 8.50781 12.541 8.75391 12.541C9.00391 12.541 9.20117 12.6152 9.3457 12.7637C9.49023 12.9082 9.5625 13.0918 9.5625 13.3145C9.5625 13.5293 9.49219 13.709 9.35156 13.8535C9.21094 13.998 9.01172 14.0703 8.75391 14.0703C8.49609 14.0703 8.29688 13.998 8.15625 13.8535C8.01953 13.709 7.95117 13.5293 7.95117 13.3145Z"
  }));
};

Info.propTypes = {
  className: _propTypes["default"].string
};
var _default = Info;
exports["default"] = _default;